module.exports = __webpack_public_path__ + "media/images/desktop/seen_status_unread-bfdd102b070afe2ae3a0fb0daeaec2bc.svg";